import styled from 'styled-components';
import { Button } from '../Shared/FormStyles';

export const ManagerContainer = styled.div`
	padding: 1rem 0;
`;

export const SectionTitle = styled.h3`
	font-size: 1.2em;
	margin-bottom: 0.4rem;
	color: #333;
`;

export const Hint = styled.p`
	font-size: 0.85em;
	color: #777;
	margin-bottom: 1rem;
	max-width: 62ch;
`;

export const DropZone = styled.div<{ $dragOver: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.25rem;
	padding: 1.5rem 1rem;
	border: 2px dashed
		${({ $dragOver }) => ($dragOver ? '#2e86c1' : '#c9c9c9')};
	border-radius: 10px;
	background: ${({ $dragOver }) => ($dragOver ? 'rgba(52,152,219,0.08)' : '#fafafa')};
	cursor: pointer;
	transition: background 0.15s ease, border-color 0.15s ease;
	user-select: none;

	&:hover {
		border-color: #2e86c1;
		background: rgba(52, 152, 219, 0.05);
	}

	input[type='file'] {
		display: none;
	}
`;

export const DropZoneIcon = styled.span`
	font-size: 1.6em;
	line-height: 1;
`;

export const DropZoneMainText = styled.span`
	font-size: 0.95em;
	color: #444;
`;

export const DropZoneSubText = styled.span`
	font-size: 0.78em;
	color: #999;
`;

export const PendingRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
	margin: 0.75rem 0 0.25rem;
`;

export const PendingChip = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 0.4rem;
	max-width: 240px;
	padding: 3px 6px 3px 3px;
	border: 1px solid #dde3e8;
	border-radius: 999px;
	background: #fff;

	img {
		width: 26px;
		height: 26px;
		object-fit: cover;
		border-radius: 50%;
		flex: 0 0 auto;
	}

	span {
		font-size: 0.78em;
		color: #444;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	button {
		flex: 0 0 auto;
		border: none;
		background: #eee;
		color: #666;
		width: 18px;
		height: 18px;
		border-radius: 50%;
		line-height: 1;
		font-size: 0.85em;
		cursor: pointer;

		&:hover {
			background: #dc3545;
			color: #fff;
		}
	}
`;

export const ActionsRow = styled.div`
	display: flex;
	gap: 1rem;
	align-items: center;
	flex-wrap: wrap;
	margin: 0.75rem 0 1.25rem;
`;

export const UploadButton = styled(Button)``;

export const CancelButton = styled(Button)`
	background-color: #6c757d;
`;

export const ProgressLabel = styled.span`
	font-size: 0.9em;
	color: #333;
	min-width: 120px;
`;

export const ProgressBarContainer = styled.div`
	flex: 1;
	min-width: 150px;
	height: 8px;
	background: #ddd;
	border-radius: 4px;
	overflow: hidden;
`;

export const ProgressBarFill = styled.div<{ $progress: number }>`
	height: 100%;
	width: ${({ $progress }) => $progress}%;
	background: #28a745;
	transition: width 0.2s ease;
`;

export const ImageGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
	gap: 1rem;
	margin-bottom: 1.5rem;
`;

export const ImageCard = styled.div<{ $deleting?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.4rem;
	padding: 0.75rem;
	border: 1px solid #ddd;
	border-radius: 8px;
	background: #fafafa;
	opacity: ${({ $deleting }) => ($deleting ? 0.5 : 1)};
`;

// Full image, contain — pipe stickers are tall with transparency; a
// cover-crop hid exactly the part that matters (the pipe's shape).
export const ThumbBox = styled.div`
	width: 100%;
	height: 150px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 6px;
	background:
		repeating-conic-gradient(#eee 0% 25%, #fff 0% 50%) 0 0 / 16px 16px;
`;

export const ImageThumb = styled.img`
	max-width: 100%;
	max-height: 100%;
	object-fit: contain;
`;

export const ImageName = styled.span`
	font-size: 0.8em;
	color: #555;
	text-align: center;
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const ImageMeta = styled.span`
	font-size: 0.72em;
	color: #999;
	display: flex;
	gap: 0.5rem;
`;

export const DeleteButton = styled(Button)`
	background-color: #dc3545;
	font-size: 0.8em;
	padding: 4px 12px;
	align-self: center;
	margin-top: 0;
`;

export const EmptyMessage = styled.p`
	color: #888;
	font-style: italic;
`;